

import React, { Component } from 'react'
import './index.less'

/**
 * 满屏雨
 * @param url
 */

export default class index extends Component {
  state = {
    // x轴列表
    list: [],
    // y起点
    yInit: '-10vh',
    // y终点
    yEnd: '120vh',
    // y移动
    y: '-10vh',
    // 自定义样式
    styles: {},
    // 对象个数
    count: 25,
    // 每n秒调用一次
    loop: 15000,
    // 几秒后开始移动
    startMove: 0,
    // 是否循环
    isLoop: true
  }

  async componentDidMount() {
    // 初始化调用对象移动
    this.loveMove()

    if (this.state.isLoop) {
      // 每过 n 秒进行一次
      setInterval(() => {
        // 重置位置
        this.setState({
          list: [],
          y: this.state.yInit,
        })
        // 调用对象移动
        this.loveMove()
      }, this.state.loop);
    }
  }

  // 对象移动
  loveMove = async () => {
    // 初始化x轴位置
    for (let i = 0; i < this.state.count; i++) {
      let list = this.state.list
      list.push((Math.floor(Math.random() * 120) - 20) + 'vw')
      this.setState({
        list: list
      })
    }
    // n 秒后开始移动
    await setTimeout(() => {
      let list = []
      this.state.list.map((item, index) => {
        list.push((Math.floor(Math.random() * 120) - 20) + 'vw')
      })
      this.setState({
        list: list,
        y: this.state.yEnd
      })
    }, this.state.startMove);
  }

  // 动态样式
  changeStyles = (item, index, image) => {
    let mode = "liner"
    let times = ""
    return {
      transform: `translate(${item},${this.state.y}) rotate(${index}deg) scale(0.6)`,
      transitionTimingFunction: `${mode}`,
      transitionDelay: `${(((index + 5) / 6) + 1) + 's'}`,
      transitionDuration: (((index / 10) + 5) < 6) ? ((index / 10 + 5) + 's') : '6s',
      // 延迟时间 + 持续时间 < 每几秒一次的时间,
      backgroundImage: `url(${this.props.image})`
    }
  }

  render() {
    return (
      <div className='fall-main-box'>
        {
          this.state.list.map((item, index) => {
            return (
              <div className="love" key={index} style={this.changeStyles(item, index)} ></div>
            )
          })
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/DropScreen/index.js